
import { GetServerSideProps, NextPage } from 'next';
import MainLayout from '@layouts/main-layout/main-layout';
import { IAuthor,   } from '@models/author.interface';
import { getAuthors } from '@services/author.service';
import { getMatchingRedirect } from '@services/redirect.service';
import { ServerSidePropsError } from '@helpers/server-side-props-error.helper';
import { useRouter } from 'next/router';
import { MetaTags } from '@helpers/meta-tags.helper';
import AuthorsPage from '@components/blog/authors-page/authors-page';
import Head from 'next/head';

interface AuthorsProps {
    authors:IAuthor[];
}

const LIMIT = 9;


const Authors: NextPage<AuthorsProps> = ({ authors }) => {
    const { asPath } = useRouter();

    return (
        <>
          <Head>{
                MetaTags({
                    title: 'Our Authors | Agilie',
                    description: 'Meet our in-house authors, who have deep practical experience and are ready to share it with you and provide helpful knowledge derived from our company.',
                    imageUrl: '/blog-images/authors-image-meta.png',
                })
            }
                <link rel="icon" href="/favicon.ico"/>
            </Head>
            <MainLayout>
                <AuthorsPage authors={authors} />
            </MainLayout>
        </>
    );
};

export default Authors;

export const getServerSideProps: GetServerSideProps<any | ServerSidePropsError> = async (context) => {
    const { data: authorsData } = await getAuthors();
   
    if (!authorsData) {
        return {
            notFound: true,
        };
    }

    const [url] = context.resolvedUrl.split('?');
    const redirectUrl = await getMatchingRedirect(url);
    if (redirectUrl) {
        return {
            redirect: {
                destination: redirectUrl,
                permanent: true,
            },
        };
    }
    
    if (authorsData) {
        return {
            props: {
                authors:authorsData,
            },
        }
    }

    return {
        notFound: true,
    };  
};